<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="600px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>Edit Bank Account</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <custom-form
          :fields="bankaccount"
          method="put"
          :action="url"
          @submitted="$emit('edited', $event)"
        >
          <v-row no-gutters>
            <v-col cols="6" class="px-1">
              <custom-input name="title" label="Title" />
            </v-col>
            <v-col cols="6" class="px-1">
              <custom-input name="owner_name" label="Owner Name" />
            </v-col>
            <v-col cols="12" class="px-1">
              <custom-input name="bank_name" label="Bank Name" />
            </v-col>

            <v-col cols="9" class="px-1">
              <custom-select
                :items="countries"
                name="country"
                item-text="name"
                item-value="name"
                label="Country"
              />
            </v-col>
            <v-col cols="6" class="px-1">
              <custom-input name="iban" label="IBAN Code" />
            </v-col>
            <v-col cols="6" class="px-1">
              <custom-input name="bic" label="BIC Code" />
            </v-col>
            <v-col cols="12" class="px-1">
              <custom-button block color="primary">
                Update Bank Account
              </custom-button>
            </v-col>
          </v-row>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    bankaccount: {
      default: () => {},
      type: Object,
    },
  },
  computed: {
    url() {
      return `api/v1/userBankAccounts/${this.bankaccount.id}`;
    },
  },
  data() {
    return {
      countries: [],
    };
  },
  created() {
    this.$http.get("/api/v1/get-countries").then((response) => (this.countries = response));
  },
};
</script>
